import { combineReducers, Reducer } from 'redux'
import { busyReducer, BusyState } from './busy'
import { channelReducer, ChannelState } from './channel'
import { configReducer, ConfigState } from './config'
import { messagingReducer, MessagingState } from './messaging'
import { modalReducer, ModalState } from './modal'
import { profileReducer, ProfileState } from './profile'
import { toastReducer, ToastState } from './toast'
import { sessionReducer, SessionState } from './session'

export interface ApplicationState {
	busy: BusyState
	modal: ModalState
	toast: ToastState
	profile: ProfileState
	config: ConfigState
	channel: ChannelState
	messaging: MessagingState
	session: SessionState
}

export const createRootReducer = (): Reducer<ApplicationState> =>
	combineReducers<ApplicationState>({
		busy: busyReducer,
		modal: modalReducer,
		toast: toastReducer,
		profile: profileReducer,
		config: configReducer,
		channel: channelReducer,
		messaging: messagingReducer,
		session: sessionReducer
	})
